// extracted by mini-css-extract-plugin
export var icon = "TocMobile-module--icon--5b7a5";
export var select = "TocMobile-module--select--3a3f6";
export var tocMobile = "TocMobile-module--tocMobile--84c55";